import React, { useState } from "react";

import {
  Grid,
  Menu,
  Button,
  Tooltip,
  MenuItem,
  withStyles,
} from "@material-ui/core";
import { KeyboardArrowDown } from "@material-ui/icons";

import BtnResetPass from "../../Assets/Icon/btn_resetPass.png";
import BtnEdit from "../../Assets/Icon/btn_edit.png";
import BtnDelete from "../../Assets/Icon/btn_delete.png";
import BtnFilter from "../../Assets/Icon/ic_filter.png";
import IconSearch from "../../Assets/Icon/ic_search.png";
import IconDetail from "../../Assets/Icon/btn_detail.png";
import IconSort from "../../Assets/Icon/ic_sort.png";
import IconResendTicket from "../../Assets/Icon/ic_resend_ticket.png";

const resetPassBtn = <img alt="resetPassBtn" src={BtnResetPass} />;
const editBtn = <img alt="editBtn" src={BtnEdit} />;
const deleteBtn = <img alt="deleteBtn" src={BtnDelete} />;
const filterBtn = <img alt="filterBtn" src={BtnFilter} />;
const searchIcon = <img alt="searchIcon" src={IconSearch} />;
const detailBtn = <img alt="detailBtn" src={IconDetail} />;
const sortIcon = <img alt="sortIcon" src={IconSort} />;
const resendTicketIcon = <img alt="resendTicket" src={IconResendTicket} style={{ width: 30, height: 30 }} />;

export const CustomButton = withStyles((theme) => ({
  button: {
    backgroundColor: theme.palette.green,
    color: "#fff",
    fontSize: "16px",
    "&:hover": {
      backgroundColor: theme.palette.green,
    },
  },
  arrow: {
    backgroundColor: theme.palette.green,
    color: "#fff",
    fontSize: "16px",
    "&:hover": {
      backgroundColor: theme.palette.green,
    },
    borderRadius: 0,
  },
}))(
  ({
    classes: { button, arrow },
    options,
    isMultipleButton = false,
    children,
    ...props
  }) => {
    const [anchorEl, setAnchorEl] = useState(false);
    const [selectedIndex, setSelectedIndex] = useState(0);

    const handleClickIcon = (event) => {
      setAnchorEl(event.currentTarget);
    };

    const handleClickItem = (event, index) => {
      setAnchorEl(null);
      setSelectedIndex(index);
    };

    const handleClose = () => {
      setAnchorEl(null);
    };

    return (
      <Grid>
        {!isMultipleButton ? (
          <Button className={button} {...props}>
            {children}
          </Button>
        ) : (
          <div style={{ height: "100%", display: "flex" }}>
            <Button
              className={arrow}
              onClick={options[selectedIndex].handle}
              {...props}
            >
              {options[selectedIndex].label}
            </Button>
            <Button onClick={handleClickIcon} className={arrow} {...props}>
              <KeyboardArrowDown />
            </Button>
            <Menu
              id="menu-item"
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={handleClose}
              keepMounted
            >
              {options.map((option, index) => (
                <MenuItem
                  key={index}
                  selected={index === selectedIndex}
                  onClick={(event) => handleClickItem(event, index)}
                >
                  {option.label}
                </MenuItem>
              ))}
            </Menu>
          </div>
        )}
      </Grid>
    );
  },
);

export const Sync = withStyles((theme) => ({
  button: {
    backgroundColor: theme.palette.lightBlue,
    color: "#fff",
    textTransform: "none",
    fontSize: "16px",
    "&:hover": {
      backgroundColor: theme.palette.lightBlue,
    },
  },
}))(({ classes: { button }, ...props }) => (
  <Button className={button} {...props}>
    Sync
  </Button>
));

export const ResetPass = ({ ...props }) => (
  <Tooltip title="Reset Password" placement="bottom" arrow>
    <Button {...props}>{resetPassBtn}</Button>
  </Tooltip>
);

export const Edit = ({ ...props }) => (
  <Tooltip title="Edit" placement="bottom" arrow>
    <Button {...props}>{editBtn}</Button>
  </Tooltip>
);

export const Delete = ({ ...props }) => (
  <Tooltip title="Delete" placement="bottom" arrow>
    <Button {...props}>{deleteBtn}</Button>
  </Tooltip>
);

export const Filter = ({ ...props }) => (
  <Tooltip title="Filter" placement="bottom" arrow>
    <Button {...props}>{filterBtn}</Button>
  </Tooltip>
);

export const Search = ({ ...props }) => (
  <span>
    <Button {...props}>{searchIcon}</Button>
  </span>
);

export const Detail = ({ isCustom, customTooltipTitle, ...props }) => (
  <Tooltip
    title={isCustom ? customTooltipTitle : "Detail"}
    placement="bottom"
    arrow
  >
    <Button {...props}>{detailBtn}</Button>
  </Tooltip>
);

export const Sort = ({ ...props }) => (
  <Tooltip title="Sort" placement="bottom" arrow>
    <Button {...props}>{sortIcon}</Button>
  </Tooltip>
);

export const ResendTicket = ({ ...props }) => (
  <Tooltip title="Resend Ticket" placement="bottom" arrow>
    <Button {...props}>{resendTicketIcon}</Button>
  </Tooltip>
);

/**
 * Kustomisasi komponen untuk simpan dan cancel
 * Propsnya ada title, onClickCancel, dan onClickConfirm
 */
export const SimpanCancel = withStyles((theme) => ({
  button: {
    backgroundColor: theme.palette.blue,
    color: "white",
    "&:hover": {
      backgroundColor: theme.palette.blue,
    },
  },
}))(
  ({ classes: { button }, title, onClickCancel, onClickConfirm, ...props }) => (
    <Grid>
      <Button
        disableElevation
        variant="contained"
        color="secondary"
        onClick={onClickCancel}
      >
        CANCEL
      </Button>
      <Button className={button} onClick={onClickConfirm} {...props}>
        {title}
      </Button>
    </Grid>
  ),
);
